import { useQuery } from "react-query";
import { getData } from "../newApis/apiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { IResponse } from "../interfaces/response";

export type AuditTrailType = {
  id: number;
  name: string;
};

export const getAuditTrailTypes = async (): Promise<
  IResponse<AuditTrailType[]>
> => {
  const data = await getData(ajaxEndpoints.PRODUCT_AUDITS_TYPE);
  return data;
};

export default function useAuditTrailTypes() {
  return useQuery<IResponse<AuditTrailType[]>>(
    ["getAuditTrailTypes"],
    getAuditTrailTypes
  );
}
